<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <h1 align="center" style="text-decoration: underline overline;">HK5 - AKTIVITI BUKAN PERTANIAN DAN BUKAN ICT (PENGANGKUTAN)</h1>
        <!-- <h1 align="center" > Pengangkutan</h1> -->
        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          width="20px"
          disabled
        ></v-text-field>

          <!-- DATATABLE  -->
          <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
                <v-card-title>
                    Senarai
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                
                <v-spacer></v-spacer>
                    <v-btn
                    color="error"
                    small
                    @click="dialogPengesahan=true;"
                    >
                      Padam
                    </v-btn>
                
                </v-card-title>
                
                <v-data-table
                  :headers="headers"
                  :items="dataHK5"
                  :search="search"
                  class="ml-3 mr-3"
                  @click:row="handleClick"
                  :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
                >
            <template v-slot:item.HK5B1= "{ item }">
                 {{ formatNumber(item.HK5B1) }}
            </template> 
            <template v-slot:item.HK5A4= "{ item }">
                 {{ formatNumber(item.HK5A4) }}
            </template>
            <template v-slot:item.HK5A2= "{ item }">
                 {{ formatNumber(item.HK5A2) }}
            </template> 
            <template v-slot:item.HK5A3= "{ item }">
                 {{ formatNumber(item.HK5A3) }}
            </template> 
            
            <template v-slot:item.HK5C1= "{ item }">
                 {{ formatNumber(item.HK5C1) }}
            </template> 
            <template v-slot:item.HK5C3= "{ item }">
                 {{ formatNumber(item.HK5C3) }}
            </template> 
            <template v-slot:item.HK5C4= "{ item }">
                 {{ formatNumber(item.HK5C4) }}
            </template> 
            <template v-slot:item.HK5INCS21di= "{ item }">
                 {{ formatNumber(item.HK5INCS21di) }}
            </template>
            <template v-slot:item.HK5INCS21d= "{ item }">
                 {{ formatNumber(item.HK5INCS21d) }}
            </template>  
            <template v-slot:item.HK5INCS21dii= "{ item }">
                 {{ formatNumber(item.HK5INCS21dii) }}
            </template>
            <template v-slot:item.HK5INCS21diii= "{ item }">
                 {{ formatNumber(item.HK5INCS21diii) }}
            </template>  
            
            <!-- <template v-slot:item.HKINCS= "{ item }">
                 {{ formatNumber(item.totalHK5INCS21d) }}
            </template> -->
           

              </v-data-table>
          </v-card>
        </v-card>   


<v-card>
  <v-card-title>
    Pendapatan daripada bekerja sendiri (Pengangkutan)
  </v-card-title>

  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >

      <!-- s24 -->
      <v-row v-show="showS24">
        <v-col>
        S24 : Apakah jenis pekerjaan anda atau ahli isi rumah? <strong>[PK]</strong>
        <v-autocomplete
            :items="masco"
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="HK5PK"
        ></v-autocomplete>
        </v-col>
      </v-row>

      <!-- s25 -->
      <v-row v-show="showS25">
        <v-col>
        S25 : Apakah aktiviti/hasil pengeluaran utama (industri) tempat anda bekerja? <strong>[PN]</strong>
        <v-autocomplete
            :items='msic'
            :item-text="item => item.kod +' - '+ item.keterangan"
            return-object
            outlined
            dense
            v-model="HK5PN"
        ></v-autocomplete>
        </v-col>
      </v-row>

     <!-- s26 -->
      <v-row>
        <v-col>
        S26 : Nyatakan tempoh bagi soalan S24 <strong>[M]</strong>
          <v-row>
            <!-- datepicker mula -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="dateMula"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateMula"
                    label="Mula"
                    readonly
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateMula"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu1 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu1.save(dateMula)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- datepicker tamat -->
            <!-- <v-col
              cols="6"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="dateTamat"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateTamat"
                    label="Tamat"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTamat"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(dateTamat);kiraTempoh()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col> -->

            <!-- tempoh Sebenar -->
            <!-- <v-col cols="1">
              <v-text-field
                  v-model="Msebenar"
                  label="Tempoh Sebenar(bulan)"
                  outlined
                  disabled
                  dense
              ></v-text-field>
            </v-col> -->

            <!-- tempoh -->
            <v-col cols="4">
              <v-autocomplete
                  min="0"
                  maxlength="2"
                  :items="tambahlookupbulan"
                  v-model="HK5M"
                  label="Tempoh(bulan)"
                  outlined
                  dense
                  :item-text="item => item.id"
                  item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

 <v-form ref="form2"  :disabled="disabledInput"> <!-- disable input kalau month NaN/empty -->
   
      <!-- s38 -->
      <v-row>                                             
          <v-col cols="4">
          S38. Mempunyai akaun penyata kira-kira? 
          <v-select
              :items="yaTidak"
              item-text="desc"
              return-object
              solo
              dense
              v-model="HK5S38"
          ></v-select>          
          </v-col>                                 
      </v-row>

<div v-show="soalanAkaunPenyataYa">
      <!-- s39 -->
      <v-row>
        <v-col>
          S39 : Tempoh penyata kira-kira (dalam bulan)
          <v-row>
              <v-col cols="4" sm="6" md="4">
                <v-text-field
                      v-model="HK5S39"
                      label="bulan"
                      outlined
                      type="number"
                      dense
                      @keypress="limit2Digits"
                    :rules="schemeRule.no2digit"
                ></v-text-field>
              </v-col>

          </v-row>
        </v-col>
      </v-row>

      <!-- s40 -->
      <v-row v-show="showS40">
        <v-col>
          S40. Keuntungan bersih sebagaimana tercatat dalam penyata kira-kira dalam 12 bulan yang lalu <strong>[B1]</strong>                                                        
          <v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK5b1"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s41 -->
      <v-row v-show="showS41">
        <v-col>
          S41. Anggaran keuntungan bersih berdasarkan penyata kira-kira tahun sebelum ini dalam 12 bulan yang lalu <strong>[B2]</strong> <v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK5b2"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
</div>

<div v-show="soalanAkaunPenyataTidak">
      <!-- s61 -->
      <v-row>
        <v-col>
          S61. Nyatakan jumlah bulan berniaga dalam setahun <strong>[A1]</strong> <v-row>
            <v-col cols="4" sm="4" md="4">
              Tempoh Bekerja
              <v-text-field
                    v-model="HK5a1"
                    label="Bulan"
                    outlined
                    type="number"
                    dense
                    @keypress="limit2Digits"
                    :rules="schemeRule.no2digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s62 -->
      <v-row>
        <v-col>
          S62. Nyatakan purata penerimaan daripada jualan bulanan <strong>[A2]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5a2"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s63 -->
      <v-row>
        <v-col>
          S63. Purata perbelanjaan bulanan <br><strong>[A3]</strong>
          Termasuk gaji dan upah, sewa ruang pejabat, elektrik, bahan bakar, air, pembaikan dan penyelenggaraan, cukai tidak langsung misalnya cukai tanah, cukai pintu, dll., nilai barang-barang yang dibeli untuk dijual semula, harga pembelian barang-barang mentah dan perbelanjaan lain
          <v-row>
              <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5a3"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>  
          </v-row>     
        </v-col>
      </v-row>
</div>

      <!-- s64 -->
      <v-row>
        <v-col>
          S64. Purata keuntungan bersih bulanan <strong>[A4]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5a4"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>
          </v-row>          
        </v-col>
      </v-row>

      <!-- s65 -->
      <v-row>
        <v-col>
          S65. Pendapatan bersih <strong>[C1]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5C1"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s66 -->
      <!-- <v-row>
        <v-col>
          S66. Peratus pembahagian di C1 yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5C2"
                    label="Peratus"
                    outlined
                    type="number"
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row> -->
        <v-row>
        <v-col>
          S66. Peratus pembahagian di C1 yang dipegang oleh ahli isi rumah <strong>[C2]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5C2"
                    label="%"
                    outlined
                    type="number"
                    dense
                    @keypress="limit3Digits"
                    :rules="schemeRule.no3digit"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s67 -->
      <v-row>
        <v-col>
          S67. Nilai mutlak bagi C2 <strong>[C3]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5C3"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
                    persistent-hint
                    hint="Setahun"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s68 -->
      <v-row>
        <v-col>
          S68. Anggaran barangan keluaran yang digunakan sendiri setahun dalam 12 bulan yang lalu <strong>[C4]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5C4"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col> 
          </v-row>         
        </v-col>
      </v-row>

      <!-- s69 -->
      <v-row>
        <v-col>
          S69. Pendapatan bersih yang diterima oleh isi rumah <strong>[C5]</strong>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field                    
                    v-model="HK5INCS21d"
                    label="RM"
                    outlined
                    type="number"
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
                    disabled
              ></v-text-field>
            </v-col>  
          </v-row>        
        </v-col>
      </v-row>

      <!-- s70-->
      <v-row>
        <v-col>
          S70. Pendapatan daripada C5: <br>          
          <v-row class="mt-2">
            <v-col cols="4" sm="4" md="4">
              i. Pendapatan berkaitan pengangkutan dalam talian melalui transaksi e-dagang (cth: menerima pesanan melalui grab, mycar, foodpanda, lalamove, laman web khusus dan lain-lain) <strong>[INCS21d(i)]</strong>
              <!-- <v-text-field
                    v-model="HK521di"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK5INCS21di"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>

              
            </v-col>

            <v-col cols="4" sm="4" md="4">
              ii. Pendapatan berkaitan pengangkutan dalam talian melalui transaksi bukan e-dagang (cth: menerima pesanan melalui whatsapp, emel, dan lain-lain) <strong>[INCS21d(ii)]</strong>
              <!-- <v-text-field
                    v-model="HK521dii"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK5INCS21dii"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>  
            </v-col>

            <v-col cols="4" sm="4" md="4">
              iii. Pendapatan berkaitan pengangkutan bukan dalam talian <strong>[INCS21d(iii)]</strong>
              <br>
              <br>
              <!-- <br> -->
              <!-- <v-text-field
                    v-model="HK521diii"
                    outlined
                    type="number"
                    hint="%"
                    persistent-hint
                    dense
                    :rules="[rules.percentage,rules.takmauPoint]"
              ></v-text-field> -->
              <v-text-field
                    v-model="HK5INCS21diii"
                    label=RM
                    outlined
                    type="number"
                    persistent-hint
                    dense
                    @keypress="limitDigits"
                    :rules="schemeRule.no8digit"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- s71 -->
      <!-- <v-row>
        <v-col>
          S71. Nyatakan komisen daripada aktiviti 
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field
                    v-model="HK5INCS21c"
                    label="RM"
                    outlined
                    type="number"
                    dense
              ></v-text-field>
            </v-col>  
          </v-row>        
        </v-col>
      </v-row> -->
    </v-form>
  </v-form>
      <!-- s37 -->
      <v-row>
        <v-col cols="6">
        S37 : Adakah anda atau ahli isi rumah mempunyai pekerjaan lain dalam tempoh 12 bulan yang lalu? <strong>[KL]</strong>
        <v-select
            :items="yaTidak"
            item-text="desc"
            return-object
            solo
            dense
            v-model="HK5KL"
        ></v-select>
        </v-col>
      </v-row>

  </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="updateHK5()"
    >
      Kemaskini
    </v-btn>
    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="goTo('2')"
    >
      Seterusnya
    </v-btn>
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  
<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      max-width="800"
      height="200"
    >
    <v-card
      color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>

      <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <!-- <v-btn
                color="primary"
                @click='goTo("1")'
            >
              Ke Ringkasan Isi Rumah
            </v-btn> -->
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

<!-- Kemaskini Dialog -->
<v-dialog
      v-model="kemaskiniDialog"
      max-width="800"
      height="200"
    >
    <v-card
    >
      <v-alert
        dense
        solo
      >
      <strong>Data Dipilih, Sila Mulakan Pengemaskinian</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Pengesahan Padam Dialog -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogPengesahan"
      persistent
      max-width="330"
    >
      <v-card>
        <v-card-text>
         <strong style="color: red"> {{$t("PERHATIAN segala pengisian anda pada borang ini akan dipadam dan pengisian semula harus dilakukan!")}}</strong><br><br>
         {{$t("Adakah anda pasti untuk memadam pengisian?")}}<br><br>
         <!-- <strong>{{$t(" HID: "+this.HID)}}</strong> -->
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="dialogPengesahan = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padamData()"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    // props:['data'],
    async beforeMount(){
        //this.getUnits('ayam')
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOAIR = dataHID.NOAIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.masco = await lookupFieldServices.getMasco(); //dapatkan lookup masco
        this.msic = await lookupFieldServices.getMsic(); //dapatkan lookup msic
        this.yaTidak = lookupFieldServices.getYaTidak();

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID


    },
    data: () => ({
        butangKemaskini: false,
        butangSimpan: true,
        disabledInput: true,
        menu1:'',
        dateMula:'',
        menu2:'',
        dateTamat:'',

        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        kemaskiniDialog: false,
        dialogPengesahan: false,

        search: '',
        currNOAIRData:'',
        masco:[],
        msic:[],
        yaTidak:[],
        selectedData: [],

        soalanAkaunPenyataYa:false,
        soalanAkaunPenyataTidak:false,
        showS24: true,
        showS25: true,
        showS40 : false,
        showS41 : false,
      
        /////////////////////data declaration//////////////////////////
        HID: '',
        KAW: 1,
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:1,
        
        HK5PK:'',
        HK5PN:'', 
        HK5M:'', 
        HK5S38:0,
        HK5S39:0,
        HK5b1:0,
        HK5b2:0, 
        HK5a1:0, 
        HK5a2:0, 
        HK5a3:0, 
        HK5a4:0, 
        HK5C1:0, 
        HK5C2:0, 
        HK5C3:0, 
        HK5C4:0, 
        HK521di:0,
        HK521dii:0,
        HK521diii:0,
        //HK5INCS21d:'',kenapa tutup sebelum ni ?
        HK5INCS21di:0, 
        HK5INCS21dii:0, 
        HK5INCS21diii:0, 
        HK5INCS21c:'', 
        HK5KL:'',        
        dataHK5: [],
        
        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'HID', value: 'HID' },
          { text: 'NOAIR', value: 'NOAIR' },
          { text: 'HK5PK', value: 'HK5PK' },
          { text: 'HK5PN', value: 'HK5PN' },
          { text: 'HK5M', value: 'HK5M' },
          { text: 'HK5S38', value: 'HK5S38' },
          { text: 'HK5S39', value: 'HK5S39' },
          { text: 'HK5B1', value: 'HK5B1' },
          { text: 'HK5B2', value: 'HK5B2' }, 
          { text: 'HK5A1', value: 'HK5A1' }, 
          { text: 'HK5A2', value: 'HK5A2' }, 
          { text: 'HK5A3', value: 'HK5A3' }, 
          { text: 'HK5A4', value: 'HK5A4' }, 
          { text: 'HK5C1', value: 'HK5C1' }, 
          { text: 'HK5C2', value: 'HK5C2' }, 
          { text: 'HK5C3', value: 'HK5C3' }, 
          { text: 'HK5C4', value: 'HK5C4' }, 
          { text: 'HK5INCS21d', value: 'HK5INCS21d' }, 
          { text: 'HK5INCS21di', value: 'HK5INCS21di' }, 
          { text: 'HK5INCS21dii', value: 'HK5INCS21dii' }, 
          { text: 'HK5INCS21diii', value: 'HK5INCS21diii' }, 
          
          { text: 'HK5KL', value: 'HK5KL' },
         

        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
        {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        
          {
          text: 'HK5',
          disabled: true,
          href: 'hk5',
        },
        
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
        required: v => !!v || 'field is required',
        emel: (value) => {
          return /.+@.+\..+/.test(value) || 'E-mail must be valid'
        },
        percentage:(value)=>{
          return (value <= 100) || 'Percentage must between 1 - 100'
        },
        takmauPoint:(value)=>{
          return (value % 1 === 0)? true:'No point needed'
        }
          
        },
      
      select: null,
      checkbox: false,
    }),

    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8) {
            event.preventDefault();
        }
      },
      formatNumber(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
      return value.replace(/,/g, '');
      },

      limit2Digits(event) {
        const value = event.target.value;
        if (value.length >= 2) {
            event.preventDefault();
        }
      },

      limit3Digits(event) {
        const value = event.target.value;
        if (value.length >= 3) {
            event.preventDefault();
        }
      },
     
      

      async simpan (){
  
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/HK5`, {
            HID: this.HID,
            NOAIR: this.NOAIR,
            KAW: this.KAW,
            Bulan: this.Bulan,
            Tahun: this.Tahun,
            IDBPK: this.IDBPK,
            HK5PK: this.HK5PK.kod,
            HK5PN: this.HK5PN.kod,
            // dateMula: this.dateMula,
            // dateTamat: this.dateTamat, 
            HK5M: this.HK5M, 
            HK5S38: this.HK5S38.id,
            HK5S39: this.HK5S39,
            HK5b1: this.HK5b1,
            HK5b2: this.HK5b2, 
            HK5a1: this.HK5a1, 
            HK5a2: this.HK5a2, 
            HK5a3: this.HK5a3, 
            HK5a4: this.HK5a4, 
            HK5C1: this.HK5C1, 
            HK5C2: this.HK5C2, 
            HK5C3: this.HK5C3, 
            HK5C4: this.HK5C4, 
            HK521di: this.HK521di, 
            HK521dii: this.HK521dii, 
            HK521diii: this.HK521diii, 
            HK5INCS21d: this.HK5INCS21d, 
            HK5INCS21di: this.HK5INCS21di, 
            HK5INCS21dii: this.HK5INCS21dii, 
            HK5INCS21diii: this.HK5INCS21diii, 
            HK5INCS21c: this.HK5INCS21c, 
            HK5KL: this.HK5KL.id,

            //////////total yang perlu diupdate ke jr5///////////
                totalHK5INCS21d : this.totalHK5INCS21d,
                totalHK5INCS21di : this.totalHK5INCS21di,
                totalHK5INCS21dii : this.totalHK5INCS21dii,
                totalHK5INCS21diii : this.totalHK5INCS21diii,
            
              })
              this.res = res.data;
                this.reset();
                this.getData();
                this.successMessage = 'Data Disimpan!';
                this.successDialog = true;
                window.scrollTo(0, 0);
                this.butangSimpan = true;

                // this.successMessage = 'Data Disimpan!';
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
      async updateHK5(){
    

            try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/updateHK5`, {
                
                HID: this.HID,
                NOAIR: this.NOAIR,
                KAW: this.KAW,
                Bulan: this.Bulan,
                Tahun: this.Tahun,
                IDBPK: this.IDBPK,
                HK5PK: this.HK5PK,
                HK5PN: this.HK5PN,
                // dateMula: this.dateMula,
                // dateTamat: this.dateTamat, 
                HK5M: this.HK5M, 
                HK5S38: this.HK5S38.id,
                HK5S39: this.HK5S39,
                HK5b1: this.HK5b1,
                HK5b2: this.HK5b2, 
                HK5a1: this.HK5a1, 
                HK5a2: this.HK5a2, 
                HK5a3: this.HK5a3, 
                HK5a4: this.HK5a4, 
                HK5C1: this.HK5C1, 
                HK5C2: this.HK5C2, 
                HK5C3: this.HK5C3, 
                HK5C4: this.HK5C4, 
                HK521di: this.HK521di, 
                HK521dii: this.HK521dii, 
                HK521diii: this.HK521diii, 
                HK5INCS21d: this.HK5INCS21d, 
                HK5INCS21di: this.HK5INCS21di, 
                HK5INCS21dii: this.HK5INCS21dii, 
                HK5INCS21diii: this.HK5INCS21diii, 
                HK5INCS21c: this.HK5INCS21c, 
                HK5KL: this.HK5KL.id,

                //////////total yang perlu diupdate ke jr5///////////
                totalHK5INCS21d : this.totalHK5INCS21d,
                totalHK5INCS21di : this.totalHK5INCS21di,
                totalHK5INCS21dii : this.totalHK5INCS21dii,
                totalHK5INCS21diii : this.totalHK5INCS21diii,


              })
                this.res = res.data;
                this.reset();
                this.getData();
                this.butangKemaskini = false;
                this.successMessage = 'Data Dikemaskini!';
                this.successDialog = true;
                window.scrollTo(0, 0);

                // this.butangKemaskini = false;
                // this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                // this.successMessage = 'Data Dikemaskini!';
                // this.reset();
                // this.getData();
                // window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }

        
      },
      async padamData(){

        try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/HK/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
                table: "HK5"
              })
                this.res = res.data;
                this.reset();
                this.dialogPengesahan = false;
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Dipadam!'
                this.getData(); 
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }  
      },
      async getData(){
        //dapatkan data dari table HK5 based on HID
   
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/HK/HK5?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data
            this.dataHK5 = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }
      },
      handleClick(row) {

          this.selectedData = [];
          this.selectedData = row;

          this.kemaskiniDialog = true;
          setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.showS24 = false;
          this.showS25 = false;
          this.butangSimpan = false;
          this.butangKemaskini = true;

          this.NOAIR = row.NOAIR;
          this.HK5PK = row.HK5PK;
          this.HK5PN = row.HK5PN;
          // this.dateMula = row.dateMula;
          // this.dateTamat = row.dateTamat;
          this.HK5M = row.HK5M;
          this.HK5S38 = row.HK5S38;
          this.HK5S39 = row.HK5S39;
          this.HK5b1 = this.stripCommas(row.HK5B1);
          // this.HK5b2 = row.HK5B2;
          // this.HK5a1 = row.HK5B1;
          // this.HK5C2 = row.HK5C2;
          this.HK5a2 = this.stripCommas(row.HK5A2);
          this.HK5a3 = this.stripCommas(row.HK5A3);
          this.HK5a4 = this.stripCommas(row.HK5A4);
          this.HK5C1 = this.stripCommas(row.HK5C1);
          this.HK5C3 = this.stripCommas(row.HK5C3);
          this.HK5C4 = this.stripCommas(row.HK5C4);
         
           this.HK5INCS21d = this.stripCommas(row.HK5INCS21d);
           this.HK5INCS21di = this.stripCommas(row.HK5INCS21di);
           this.HK5INCS21dii = this.stripCommas(row.HK5INCS21dii);
           this.HK5INCS21diii = this.stripCommas(row.HK5INCS21diii);
          // this.HK5INCS21c = this.stripCommas(row.HK5INCS21c);

          if(row.HK5S38 == 1){
            this.HK5S38 = this.yaTidak[0];
          }
          if(row.HK5S38 == 2){
            this.HK5S38 = this.yaTidak[1];
          }
            
          if(row.HK5KL == 1){
            this.HK5KL = this.yaTidak[0];
          }
          if(row.HK5KL == 2){
            this.HK5KL = this.yaTidak[1];
          }     
          
          // or just do something with your current clicked row item data
          //console.log(row)
      },
      // kiraTempoh(){
        
      //   var d1 = new Date(this.dateMula);
      //   var d2 = new Date(this.dateTamat);
        
      //   var months;
      //   months = (d2.getFullYear() - d1.getFullYear()) * 12;
      //   months -= d1.getMonth();
      //   months += d2.getMonth();
      //   this.HK5M = months;

      //   // if(months <= 0){
      //   //   // To calculate the time difference of two dates
      //   //   var Difference_In_Time = d2.getTime() - d1.getTime();
            
      //   //   // To calculate the no. of days between two dates
      //   //   var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      //   //   months = '0.'+Difference_In_Days
      //   //   console.log(months)
      //   // }else{
      //   //   console.log(months)
      //   // }
        
      //   // return months <= 0 ? 0 : months;
      // },
      goTo(option){

        if(option == "1"){
          this.$router.push({name: "ringkasanMaklumatIR"});
        }

        if(option == "2"){
      
          if(this.HK5KL.id == "1"){
            this.$router.push({name: "JRB"});
          }
          if(this.HK5KL.id == "2"){
            this.$router.push({name: "ringkasanMaklumatIR"});
          }
         
        }   
      }

      // changeS38(val){
      //   var valueS38 = val.id;
      //   if(valueS38 == 1){
      //     this.soalanAkaunPenyataYa = true;
      //     this.soalanAkaunPenyataTidak = false;
          
      //   }
      //   if(valueS38 == 2){
      //     this.soalanAkaunPenyataYa = false;
      //     this.soalanAkaunPenyataTidak = true;
      //   }
      // }
    },
    watch:{
      HK5S38(val){
        var valueS38 = val.id;
        if(valueS38 == 1){
          this.HK5a1 = 0;
          this.HK5a2 = 0;
          this.HK5a3 = 0;
          this.soalanAkaunPenyataYa = true;
          this.soalanAkaunPenyataTidak = false;
        }
        if(valueS38 == 2){
          this.HK5S39 = 0;
          this.HK5b1 = 0;
          this.HK5b2 = 0;
          this.soalanAkaunPenyataYa = false;
          this.soalanAkaunPenyataTidak = true;
        }

      },
      HK5S39(){
        if(this.HK5S39 >=6){
          this.showS40 = true;
          this.showS41 = false;
        }else{
          this.showS40 = false;
          this.showS41 = true;
        }
      },
      // HK521di(){
      //   this.HK5INCS21di = Number(this.HK521di)*Number(this.HK5INCS21d)/100;
      // },
      // HK521diii(){
      //   this.HK5INCS21diii = Number(this.HK521diii)*Number(this.HK5INCS21d)/100;
      // },
      // HK5a3(){
      //   this.HK5a4 = Number(this.HK5a2)-Number(this.HK5a3);
      // },
      // HK5b1(){
      //   this.HK5C1 = this.HK5b1;
      // },
      // HK5b2(){
      //   this.HK5C1 = this.HK5b2;
      // },
      // HK5a4(){
      //   this.HK5C1 = Number(this.HK5a4) * Number(this.HK5a1);
      // },
      // HK5C2(){
      //   this.HK5C3 = Number(this.HK5C1) * Number(this.HK5C2)/100;
      // },
      // HK5C4(){
      //   this.HK5INCS21d = Number(this.HK5C3) + Number(this.HK5C4);
      // },
      // HK521dii(){
      //   this.HK5INCS21dii = Number(this.HK521dii)*Number(this.HK5INCS21d)/100;

      //   this.HK521diii = Number(this.HK521di) + Number(this.HK521dii);
      //   this.HK521diii = 100 - Number(this.HK521diii);
      // },
      HK5M(val){
    
        if(isNaN(val)){
            this.disabledInput = true;
          }else{
            this.disabledInput = false;
        }
      }
    },
    computed:{
      // HK5M: function(){
      //   var d1 = new Date(this.dateMula);
      //   var d2 = new Date(this.dateTamat);
        
      //   var months;
      //   months = (d2.getFullYear() - d1.getFullYear()) * 12;
      //   months -= d1.getMonth();
      //   months += d2.getMonth()+1;

      //     if(months > 12){
      //       return 12
      //     }else{
      //       return months
      //     }
      // },
      // Msebenar: function(){
      //     var d1 = new Date(this.dateMula);
      //     var d2 = new Date(this.dateTamat);
          
      //     var months = 0;
      //     months = (d2.getFullYear() - d1.getFullYear()) * 12;
      //     months -= d1.getMonth();
      //     months += d2.getMonth()+1;

      //     return months;
      // },
      HK5INCS21d:  function(){
          var total = 0;
          //total = total + Number(this.HK5INCS21d);
          total = Number(this.HK5C3) + Number(this.HK5C4);
          return total;
      }, 
      tambahlookupbulan() {
      return lookup.getBulan();
      },
      totalHK5INCS21d:  function(){
          var total = 0;
          if(this.dataHK5.length >= 1){
            ///calculate semua value HK2INCS21d yang telah di insert
            for(var i = 0; i < this.dataHK5.length ; i++){
              total = total + Number(this.dataHK5[i].HK5INCS21d)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21d yang bakal diinsert
          //total = total + Number(this.HK5INCS21d) - Number(this.selectedData.HK5INCS21d);
          if(this.selectedData.HK5INCS21d){
              total = total + Number(this.HK5INCS21d) - Number(this.selectedData.HK5INCS21d);
          }else{
              total = total + Number(this.HK5INCS21d) ;
          }
          return total;
      }, 
      totalHK5INCS21di:  function(){

          var total = 0;
          if(this.dataHK5.length >= 1){
            ///calculate semua value HK2INCS21di yang telah di insert
            for(var i = 0; i < this.dataHK5.length ; i++){
              total = total + Number(this.dataHK5[i].HK5INCS21di)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21di yang bakal diinsert
          //total = total + Number(this.HK5INCS21di) - Number(this.selectedData.HK5INCS21di);
          if(this.selectedData.HK5INCS21di){
              total = total + Number(this.HK5INCS21di) - Number(this.selectedData.HK5INCS21di);
          }else{
              total = total + Number(this.HK5INCS21di) ;
          }
          return total;

      }, 
      totalHK5INCS21dii:  function(){

          var total = 0;
          if(this.dataHK5.length >= 1){
            ///calculate semua value HK2INCS21dii yang telah di insert
            for(var i = 0; i < this.dataHK5.length ; i++){
              total = total + Number(this.dataHK5[i].HK5INCS21dii)
            }
          }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21dii yang bakal diinsert
          //total = total + Number(this.HK5INCS21dii) - Number(this.selectedData.HK5INCS21dii);
          if(this.selectedData.HK5INCS21dii){
              total = total + Number(this.HK5INCS21dii) - Number(this.selectedData.HK5INCS21dii);
          }else{
              total = total + Number(this.HK5INCS21dii) ;
          }
          return total

      }, 
      totalHK5INCS21diii:  function(){

         var total = 0;
         if(this.dataHK5.length >= 1){
          ///calculate semua value HK2INCS21diii yang telah di insert
          for(var i = 0; i < this.dataHK5.length ; i++){
            total = total + Number(this.dataHK5[i].HK5INCS21diii)
          }
         }

          ///tambahkan total yang telah diinsert dengan current HK2INCS21diii yang bakal diinsert
          //total = total + Number(this.HK5INCS21diii) - Number(this.selectedData.HK5INCS21diii);
          if(this.selectedData.HK5INCS21diii){
              total = total + Number(this.HK5INCS21diii) - Number(this.selectedData.HK5INCS21diii);
          }else{
              total = total + Number(this.HK5INCS21diii) ;
          }
          return total

      }, 

      schemeRule() {
      return schemeRule;
    },
    }
}
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>